import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '../store/rootReducers';

const store = configureStore({
  reducer: rootReducer,
});

export default store;
